import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { Pencil, Trash2 } from "lucide-react";

export function PestcontrolRowActions({
  onEdit,
  onDelete,
}: {
  onEdit: () => void;
  onDelete: () => Promise<unknown>;
}) {
  return (
    <div className="flex justify-end gap-1">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="outline" size="icon" onClick={onEdit}>
              <Pencil className="size-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t("Bearbeiten")}</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              onClick={() => void onDelete()}
            >
              <Trash2 className="size-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t("Löschen")}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
